module.exports = __webpack_public_path__ + "img/loading.4d415bb5.gif";